import apiReport from '@/api/report';
import apiOption from '@/api/option';

const defaultState = () => ({
    headers: [],
    salesOrderReport: [],
    salesOrderFooter: [],
    salesRetailReport: [],
    salesRetailFooter: [],
	isLoading: false,
	grandTotal: [],
	summaryDigital:{},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	setReport(state, data) {
		state.headers = []
		state.salesOrderReport =  []
		state.salesOrderFooter =  []
		state.salesRetailReport =  []
		state.salesRetailFooter =  []
		state.grandTotal = []
		if(Object.keys(data).length > 0){
			if(data.data.filters.title == 'Daily'){
				state.headers.push({
					value: 'title',
					align: 'start',
					width: '150px',
					text: 'Tanggal'
				})
			}
			if(data.data.filters.title == 'Monthly'){
				state.headers.push({
					value: 'title',
					align: 'start',
					width: '120px',
					text: 'Bulan'
				})
			}
			if(data.data.filters.title == 'Annualy'){
				state.headers.push({
					value: 'title',
					align: 'start',
					width: '120px',
					text: 'Tahun'
				})
			}
			if(data.data.filters.title == 'summary_province'){
				state.headers.push({
					value: 'title',
					align: 'start',
					width: '120px',
					text: 'Provinsi'
				})
			}
			if(data.data.filters.title == 'summary_warehouse'){
				state.headers.push({
					value: 'title',
					align: 'start',
					width: '120px',
					text: 'Warehouse'
				})
			}
			data.data.report.header.forEach((value) => {
				state.headers.push({
					value: value,
					width: '120px',
					text: value
				})
			});
			state.headers.push({
				value: 'total_product',
				align: 'end',
				width: '150px',
				text: 'Total Produk'
			})
			state.headers.push({
				value: 'total_product_price_format',
				align: 'end',
				width: '200px',
				text: 'Nominal (Rp.)'
			})
			// state.headers = data.data.report.header
			state.salesOrderReport = data.data.report.sales_order_report;
			state.salesOrderFooter = data.data.report.sales_order_footer;
			state.salesRetailReport = data.data.report.sales_retail_report;
			state.salesRetailFooter = data.data.report.sales_retail_footer;
			state.grandTotal = data.data.grand;
		}
	},
	setSummaryDigital(state, data){
		state.summaryDigital = data.data
	},
    failed(state, data) {
		state.alert = data
	},
	setLoading(state, data){
		state.isLoading = data
	},
	resetState(state){
		Object.assign(state, defaultState());
	}
}

const actions = {
	async getReport({ commit, dispatch }, params) {
		commit('setLoading', true);
		await apiReport.getDataReport(params).then(({ data: { data } }) => {
			commit('setLoading', false);
			commit('setReport', { data: data.results });
		}).catch((err) => {
			commit('setLoading', false);
			commit('setReport', { data: [] });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async getReportSummaryProvince({ commit, dispatch }, params) {
		commit('setLoading', true);
		await apiReport.getDataReportSummaryProvince(params).then(({ data: { data } }) => {
			commit('setLoading', false);
			commit('setReport', { data: data.results });
		}).catch((err) => {
			commit('setLoading', false);
			commit('setReport', { data: [] });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async getReportSummaryWarehouse({ commit, dispatch }, params) {
		commit('setLoading', true);
		await apiReport.getDataReportSummaryWarehouse(params).then(({ data: { data } }) => {
			commit('setLoading', false);
			commit('setReport', { data: data.results });
		}).catch((err) => {
			commit('setLoading', false);
			commit('setReport', { data: [] });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async getReportSummarySerialDigital({ commit, dispatch }) {
		commit('setLoading', true);
		await apiReport.getDataSummarySerialDigital().then(({ data: { data } }) => {
			commit('setLoading', false);
			commit('setSummaryDigital', { data: data.results });
		}).catch((err) => {
			commit('setLoading', false);
			commit('setSummaryDigital', { data: [] });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getOptionWarehouse({ dispatch }) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionProvince({ dispatch }) {
		return new Promise((resolve) => {
			apiOption.getOptionProvince().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionCity({ dispatch }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionCity({province_id: params}).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				resolve([]);
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionSubdistrict({ dispatch }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionSubdistrict({city_id: params}).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				resolve([]);
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
    errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};